<template>
  <div class="new-project-control-buttons">
    <span class="escape-link d-inline-block" @click="onEscapeClicked()"> X {{ $t('newProject.esc') }} </span>
    <span v-if="showCreateButton" class="save-button" :class="{ disabled: actionDisabled }" @click="onActionClicked()">
      {{ actionTitle }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'NewProjectControlButtons',
  props: {
    showCreateButton: {
      type: Boolean,
      default: false,
    },
    actionTitle: {
      type: String,
      required: true,
    },
    actionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onEscapeClicked() {
      this.$emit('onEscapeClicked');
    },
    onActionClicked() {
      if (!this.actionDisabled) {
        this.$emit('onActionClicked');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.new-project-control-buttons {
  display: inline-block;
  width: 33%;

  .save-button {
    float: right;
    margin-top: $space-3;
    display: inline-block;
    cursor: pointer;
    height: rem(32);
    width: rem(66);
    border-radius: $radius-sm;
    background-color: var(--brand-primary);
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    color: #ffffff;
    font-size: $font-size-sm;
    font-weight: 500;
    letter-spacing: 1.07px;
    line-height: rem(16);
    text-align: center;
    text-transform: uppercase;
    padding-top: $space-2;

    &.disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  .escape-link {
    float: right;
    cursor: pointer;
    margin-left: rem(20);
    text-align: right;
    font-size: $font-size-sm;
    text-transform: uppercase;
    text-decoration: none;
    color: var(--text-secondary);
    font-family: $font-family-medium;
    font-weight: 500;
    letter-spacing: 1.1px;
    padding-top: rem(20);
    height: rem(16);
    line-height: rem(16);
  }
}
</style>
